<template>
  <section class="container">
    <page-404 v-if="document_not_found" :message="$t('document not found')" />
    <page-500 v-if="document_expired" :message="$t('document expired')" />
    <page-200 v-if="document_signed" :message="$t('thank you for signing')" />
    <div v-if="meta.addressee && !document_signed">
      <!-- Show logo -->
      <div class="columns is-centered" v-if="meta.profile.settings.logo">
        <div class="column is-3">
          <img
            :src="`${drive_static_file_url(
              meta.profile.settings.logo.settings.final_name
            )}`"
            class="logo"
          />
        </div>
      </div>
      <div class="title is-5">{{ $t("hello") }} {{ meta.addressee.name }}</div>
      <div class="notification" v-if="meta.status_code === 'S'">
        <div class="title is-5 has-text-centered has-text-warning">
          <span class="icon has-text-success">
            <i class="fa fa-check"></i>
          </span>
          <span class="ml-1">{{ $t("this document is already signed") }}</span>
        </div>
      </div>
      <nav
        class="pagination is-centered"
        role="navigation"
        aria-label="pagination"
      >
        <div class="button pagination-previous" @click="previous_page">
          <span class="icon has-text-primary">
            <i class="fa fa-angle-left"></i>
          </span>
          <span>{{ $t("previous") }}</span>
        </div>
        <div class="button pagination-previous" @click="next_page">
          <span>{{ $t("next") }}</span>
          <span class="icon has-text-primary">
            <i class="fa fa-angle-right"></i>
          </span>
        </div>
        <div class="pagination-next p-0" v-if="meta.status_code != 'S'">
          <div class="button is-rounded is-danger" @click="reject">
            <span>{{ $t("reject") }}</span>
            <span class="icon">
              <i class="fa fa-times"></i>
            </span>
          </div>
        </div>
        <div class="pagination-next p-0" v-if="meta.status_code != 'S'">
          <div class="button is-rounded is-success" @click="sign">
            <span>{{ $t("sign") }}</span>
            <span class="icon">
              <i class="fa fa-check"></i>
            </span>
          </div>
        </div>
        <ul class="pagination-list">
          <li v-for="(page, pidx) in meta.settings.pages" :key="pidx">
            <a
              href="#"
              class="pagination-link"
              :class="{ 'is-current': active_page === pidx + 1 }"
              :aria-label="'Goto page ' + pidx + 1"
              @click="change_page(pidx + 1)"
              >{{ pidx + 1 }}</a
            >
          </li>
        </ul>
      </nav>

      <canvas id="the-canvas" style="width: 100%"></canvas>
    </div>
    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <sign-modal
      ref="sign_modal"
      :module_settings="module_settings"
      :document="meta"
      @signed="signed"
    />
  </section>
</template>

<script>
import {
  get,
  generate_error_message_text,
  api_host,
  put,
  confirm_deletion_dialog,
  error_message,
  drive_static_file_url,
} from "@/utils";
import SignModal from "./sign_modal/Index.vue";
import Page404 from "@/components/404/Index.vue";
import Page500 from "@/components/500/Index.vue";
import Page200 from "@/components/200/Index.vue";
import * as PDFJS from "pdfjs-dist";
import * as PdfWorker from "pdfjs-dist/build/pdf.worker";

// window.pdfjsWorker = PdfWorker;

PDFJS.GlobalWorkerOptions.workerSrc =
  "//mozilla.github.io/pdf.js/build/pdf.worker.mjs";

let pdf_instance = null;

export default {
  name: "DocumentView",
  components: { SignModal, Page404, Page500, Page200 },
  data() {
    return {
      api_host,
      meta: {},
      error: "",
      pdf_file_url: null,
      active_page: 1,
      module_settings: {},
      document_not_found: false,
      document_expired: false,
      document_signed: false,
    };
  },
  methods: {
    drive_static_file_url,
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    change_page(page_number) {
      let v = this;
      // console.log("fetching page", page_number);
      if (pdf_instance) {
        pdf_instance.getPage(page_number).then((page) => {
          // console.log("page", page_number, page);
          var scale = 2;
          var viewport = page.getViewport({ scale: scale });

          // Prepare canvas using PDF page dimensions
          var canvas = document.getElementById("the-canvas");
          var context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          // Render PDF page into canvas context
          var renderContext = {
            canvasContext: context,
            viewport: viewport,
          };
          var renderTask = page.render(renderContext);
          renderTask.promise.then(function () {
            v.active_page = page_number;

            /**
             * Log page as rendered
             */
            v.log(`${v.$t("page rendered")}: ${page_number}`);

            // put("/document-sign/sign/log", {
            //   uuid: v.$route.params.document_uuid,
            //   message: `Page ${page_number} rendered`,
            // })
            //   .then((response) => {
            //     // console.log("page signed", response);
            //   })
            //   .catch((error) => {
            //     console.error(error);
            //     error_message(error);
            //   });
          });
        });
      } else {
        console.error("pdf_instance not found");
      }
    },
    next_page() {
      let v = this;
      if (v.active_page < v.meta.settings.pages.length) {
        v.change_page(v.active_page + 1);
      }
    },
    previous_page() {
      let v = this;
      if (v.active_page > 1) {
        v.change_page(v.active_page - 1);
      }
    },
    reject() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to reject this document?"),
        v,
        () => {
          put("/document-sign/sign/reject", {
            uuid: v.$route.params.document_uuid,
          })
            .then(() => {
              v.log(v.$t("document rejected"));
              window.location.href =
                v.meta.profile.settings.redirect_url_reject;
            })
            .catch((error) => {
              v.error = generate_error_message_text(error);
              error_message(v.error);
            });
        },
        v.meta.profile.settings.disclaimer_reject || ""
        // v.module_settings.disclaimer_reject
      );
    },
    sign() {
      let v = this;
      v.$refs.sign_modal.show_modal();
    },
    signed() {
      let v = this;
      v.log(v.$t("document signed"));
      v.document_signed = true;
      setTimeout(() => {
        window.location.href = v.meta.profile.settings.redirect_url_sign;
      }, 3000);
    },
    log(message) {
      let v = this;
      put("/document-sign/sign/log", {
        uuid: v.$route.params.document_uuid,
        message: message,
      })
        .then((response) => {
          // console.log("page signed", response);
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        });
    },
  },
  mounted() {
    let v = this;
    let document_uuid = v.$route.params.document_uuid;
    get("/document-sign/sign", { uuid: document_uuid })
      .then((response) => {
        let { document, settings } = response;
        v.meta = document;
        v.module_settings = settings;
        if (document.settings && document.pdf_file) {
          let pdf_path = `${api_host}/drive/static/${document.pdf_file.settings.final_name}`;
          // console.log("pdf file found", pdf_path);
          v.pdf_file_url = pdf_path;
          PDFJS.getDocument(pdf_path)
            .promise.then((pdf) => {
              // let num_pages = pdf.numPages;
              // console.log("pdf loaded", pdf);
              pdf_instance = pdf;
              v.change_page(1);
            })
            .catch((error) => {
              console.error(error);
              v.error = generate_error_message_text(error);
            });
        } else {
          v.error = $t("no pdf file found");
          error_message(v.error);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.status === 404) {
          v.document_not_found = true;
        } else if (
          error.status === 500 &&
          error.data.includes("Document expired")
        ) {
          v.document_expired = true;
        } else {
          console.error(error);
          v.error = generate_error_message_text(error);
          // error_message(v.error);
        }
      });
  },
  created() {},
  watch: {},
};
</script>

<style scoped></style>
